module.exports = __webpack_public_path__ + "static/media/miner5.b79154b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Miner/miner5.png
// module id = 879
// module chunks = 0